import DrawerWrapper from "./DrawerWrapper";
import { useCart } from "../context/CartContext";
  import {silverData} from "../data/silverData";

export default function FavouritesDrawer({ open, close }) {
  const { favourites, cart, toggleFav } = useCart();

  // Your silverData


  const favItems = silverData.filter(i => favourites.includes(i.id));

  return (
    <DrawerWrapper open={open} close={close}>
      <h2 className="text-xl font-bold mb-4 p-5">Your Favourites</h2>

      {favItems.length === 0 ? (
        <p className="p-5">No favourites yet.</p>
      ) : (
        <div className="space-y-4 p-5">
          {favItems.map(item => (
            <div key={item.id} className="flex gap-3">
              <img
                src={item.image}
                className="w-16 h-16 rounded object-cover"
              />

              <div className="flex-1">
                <h3 className="font-semibold">{item.name}</h3>
                <p>₹{item.discountedPrice}</p>

                <button
                  onClick={() => toggleFav(item.id)}
                  className="text-red-500 text-sm mt-1"
                >
                  Remove ❤️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </DrawerWrapper>
  );
}
